<script lang="ts">
	import GenderSelect from '../../GenderSelect.svelte';
	import Text from '../../../Text.svelte';
	import Chip, { Text as ChipText } from '@smui/chips/styled';

	function pretifyAgeGroupArray(
		agesArray: string,
		isAgeGroup18Plus: boolean,
		isAgeGroup18Minus: boolean
	) {
		const agesNumStrings = JSON.parse(agesArray)
			.map((age: string) => age.replace('ageGroup_', ''))
			.map((age: string) => age.split('-'));

		const initValue = [];
		const reducer = (accumulator: any, item: any) => {
			const lastGroup = accumulator.slice(-1)[0];
			if (!lastGroup) return [item];

			const lastGroupLast = parseInt(lastGroup[1]);
			const itemGroupNew = parseInt(item[0]);

			const newAcc = [...accumulator];

			if (lastGroupLast + 1 === itemGroupNew) {
				const newItem = [lastGroup[0], item[1] || item[0]];
				newAcc.pop();
				newAcc.push(newItem);
				return newAcc;
			}
			return [...newAcc, item];
		};

		const result = agesNumStrings.reduce(reducer, initValue);

		if (isAgeGroup18Plus) {
			return [['18+']];
		}
		if (isAgeGroup18Minus) {
			return [['18-']];
		}

		if (!result.length) return [['any']];
		if (result.length === 1 && result[0][0] === '0' && result[0][1] === '65+') return [['any']];

		return result.map((ageGroup: string[]) => ageGroup.join(' - '));
	}

	export let row: any;
</script>

<div class="socdemo">
	{#if (row.lookalikeId !== '' && row.lookalikeId !== null) || (row.targetId !== '' && row.targetId !== null)}
		{#if row.lookalikeId !== '' && row.lookalikeId !== null}
			<div>
				Lookalike segment name:
				<Chip chip="interestListChip" class="interest-list-chip">
					<ChipText class="interest-list-chiptext">{row.lookalikeName}</ChipText>
				</Chip>
        {parseFloat(row.lookalikeCertainty) * 100}%
			</div>
		{:else}
			<div>
				Lookalike trait:
				<Chip chip="interestListChip" class="interest-list-chip">
					<ChipText class="interest-list-chiptext">{row.targetName}</ChipText>
				</Chip>
        {parseFloat(row.lookalikeCertainty) * 100}%
			</div>
		{/if}
	{:else}
		<GenderSelect small clickable={false} gender={row.socDemo.gender} />
		<div class="certainty">
			<Text type="body1">{parseFloat(row.socDemo.certainty) * 100}%</Text>
		</div>
		<div>
			{#each pretifyAgeGroupArray(row.socDemo.ageGroups, row.socDemo.isAgeGroup18Plus, row.socDemo.isAgeGroup18Minus) as ageGroup (`${row.id}${row.socDemo.id}${ageGroup}`)}
				<Chip chip="platformOkChip" class="interest-list-chip">
					<ChipText class="interest-list-chiptext">{ageGroup}</ChipText>
				</Chip>
			{/each}
		</div>
	{/if}
</div>

<style>
	.certainty {
		padding: 0 0.5rem;
	}

	.socdemo {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
</style>
